import { defineStore } from 'pinia'
import axios from 'axios'

export const SearchStore = defineStore('Search', {
  state: () => ({
    query: {
      searchTerm: '',
      searchMode: '',
      date: 0,
      categoryId: 0,
      pageNumber: 1,
      resultsPerPage: 12
    },
    filterOptions: {
      dates: [],
      categories: []
    },
    type: '',
    apiName: '',
    queryStatus: 'loading',
    totalNumberOfResults: 0,
    items: [],
    filterOptionsStatus: 'loading',
    urlParametersStatus: 'loading',
    siteUrl: ''
  }),
  actions: {
    async setSearchType(type) {
      this.type = type
      switch (type) {
        case 'pages':
          this.apiName = 'pagesapi'
          break;
        case 'articles':
          this.apiName = 'articlesapi'
          break;
        case 'events':
          this.apiName = 'eventsapi'
          break;
        case 'medwatch':
          this.apiName = 'medwatchapi'
          break;
        case 'chpnewsroom':
          this.apiName = 'chpnewsroomapi'
          break;
      }
      if (window.siteUrl != "") {
        this.siteUrl = window.siteUrl;
      }
    },
    async getFilterOptions() {
      try {
        this.filterOptionsStatus = 'loading'
        const response = await axios.get(`${this.siteUrl}/webapi/${this.apiName}/filteroptions`)
        this.filterOptions = response.data
        this.filterOptionsStatus = 'ready'
        return { success: true }
      }
      catch {
        this.filterOptionsStatus = 'error'
        return { success: false, messages: ['An unexpected error occurred.'] }
      }
    },
    async getResultsFromQuery() {
      try {
        this.queryStatus = 'loading'
        const response = await axios.post(`${this.siteUrl}/webapi/${this.apiName}/query`, this.query)
        this.items = response.data.results
        this.totalNumberOfResults = response.data.totalNumberOfResults
        this.queryStatus = 'ready'
        this.updateUrlParametersFromQuery()
        return { success: true }
      } catch {
        this.queryStatus = 'error'
        return { success: false, messages: ['An unexpected error occurred.'] }
      }
    },
    async updateSearch(searchTerm, date, categoryId) {
      this.query.pageNumber = 1
      this.items = []
      this.query.searchTerm = searchTerm
      this.query.date = date
      this.query.categoryId = categoryId
      await this.getResultsFromQuery()
    },
    async updatePageNumber(pageNumber) {
      this.query.pageNumber = pageNumber
      await this.getResultsFromQuery()
    },
    async updateQueryFromUrlParameters() {
      this.urlParametersStatus = 'loading'
      const urlParameters = new URLSearchParams(window.location.search)
      if (urlParameters.has('q')) {
        this.query.searchTerm = urlParameters.get('q')
      }
      if (urlParameters.has('mode')) {
        this.query.searchMode = urlParameters.get('mode')
      }
      if (urlParameters.has('date')) {
        this.query.date = parseInt(urlParameters.get('date'))
      }
      if (urlParameters.has('categoryid')) {
        this.query.categoryId = parseInt(urlParameters.get('categoryid'))
      }
      this.urlParametersStatus = 'ready'
    },
    async updateUrlParametersFromQuery() {
      const urlParameters = new URLSearchParams()
      if (this.query.searchTerm) {
        urlParameters.append('q', this.query.searchTerm)
      }
      if (this.query.searchMode) {
        urlParameters.append('mode', this.query.searchMode)
      }
      if (this.query.date) {
        urlParameters.append('date', this.query.date)
      }
      if (this.query.categoryId) {
        urlParameters.append('categoryid', this.query.categoryId)
      }
      const newUrl = new URL(window.location)
      newUrl.search = urlParameters.toString()
      window.history.replaceState(null, '', newUrl)
    },
  }
})
